import MySpinner from 'components/MySpinner'
import React, { useEffect } from 'react'
import { PAGE_URL_ACTIVE } from 'SiteURLs'
import { reqClosePayment } from './PaymentRequests'

interface IPaymentResponseReceiverProps {
  onReceivePayment: (price: number, message?: string) => void
}

const PaymentResponseReceiver: React.FC<IPaymentResponseReceiverProps> = ({
  onReceivePayment,
}) => {
  useEffect(() => {
    console.log(window.location.hash)

    let items = window.location.hash.split('/')

    if (items.length > 1) {
      let params: any = {}

      let params_str = items[items.length - 1]
      params_str = params_str.replace('?', '')
      items = params_str.split('&')

      items.forEach((param_str) => {
        let key_value = param_str.split('=')
        if (key_value.length === 2) {
          params[key_value[0]] = key_value[1]
        }
      })

      reqClosePayment(params.myOrderId, params.system, params.orderId, (response) => {
        console.log(response)
        if (response.status === 'success') {
          onReceivePayment(response.pay_sum)
          window.location.href = '#/' + PAGE_URL_ACTIVE
        } else {
          onReceivePayment(response.pay_sum, response.status_message)
          window.location.href = '#/' + PAGE_URL_ACTIVE
        }
      })
    }
  }, [onReceivePayment])

  return (
    <div className='d-flex justify-content-center flex-column p-2'>
      <h4 className='d-flex align-self-center'>Платеж обрабатывается</h4>
      <MySpinner />
    </div>
  )
}
export default PaymentResponseReceiver
